import common from 'components/Collectible/assets/badges/common.svg';
import epic from 'components/Collectible/assets/badges/epic.svg';
import legendary from 'components/Collectible/assets/badges/legendary.svg';
import special from 'components/Collectible/assets/badges/special.svg';
import unique from 'components/Collectible/assets/badges/unique.svg';

export default {
  common, epic, legendary, special, unique,
};
